<template>
    <div>

     <v-container>
     		<!-- Form -->
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-form v-model="valid" ref="form" lazy-validation>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>							 
                <v-flex xs12 sm6 md4 class="pr-4">
                    <v-autocomplete
                      label="Module Name"
                      item-text="menu_name"
                      item-value="id"
                      v-model="formSchema.menu_id"
                      :items="MainMenus"
                      :rules="[v => !!v || 'Field is required']" 
                      @change="getReportMaster()"
                    ></v-autocomplete>
                    <p style="color:red" id="menu_id"></p>
                  </v-flex>

                  <v-flex xs12 sm4 md4 class="pr-4">
                    <v-autocomplete
                      label="Report Name"
                      item-text="report_title"
                      item-value="id"
                      v-model="formSchema.report_id"
                      :items="ReportName"
                      :rules="[v => !!v || 'Field is required']"                     
                    ></v-autocomplete>
                    <p style="color:red" id="report_id"></p>
                  </v-flex>

                  <v-flex xs12 sm4 md4 class="pr-4">
                    <v-autocomplete
                      label="Report Page No"
                      item-text="name"
                      item-value="id"
                      v-model="formSchema.page_no"
                      :items="ReportPage"  
                      :rules="[v => !!v || 'Field is required']"                     
                    ></v-autocomplete>
                    <p style="color:red" id="report_id"></p>
                  </v-flex>

                  <v-flex xs12 sm12 md8>
                    <vue-editor v-model="formSchema.note" ></vue-editor>
                  </v-flex>

                  <v-flex xs12 sm6 md2>	
                      <v-checkbox 
                      v-model="formSchema.is_active" 
                      label="Active" 
                      :value="isActiveVal">
                      </v-checkbox>
                  </v-flex>
						</v-layout>
	                </v-container>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="success" @click.native="validateBeforeSubmit">{{btnTitle}}</v-btn>
					<v-btn color="error"  @click.native="reset">Reset</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
		<!-- /Form -->  
     </v-container>
      
    </div>
</template>

<script>
const commonService = require('../../../services/common.service');
import { VueEditor } from "vue2-editor";
import {preFix} from '../../../vuex/api'
import Axios from 'axios'
export default {
  components: {
    VueEditor
  },
    props:['formSchema'],
    data: () => ({
      valid: true,     
      isActiveVal: 0,
      MainMenus: [],
      ReportName: [],
      ReportPage:[{id: 1,name:'Page 01'},{id: 2,name:'Page 02'},{id: 3,name:'Page 03'},{id: 4,name:'Page 04'}],
      
    }),

    computed: {
      formTitle () {
        return this.formSchema.id > 0 ? 'Update Report Note' : 'New Report Note'
      },
      btnTitle () {
        return this.formSchema.id > 0 ? 'Update' : 'Save'
      },
      // Asset Location List
      getReportMaster() {
        this.selectValues = [];
        var menu_id = this.formSchema.menu_id;
        commonService
          .getAllDataById(menu_id, "get_report_master_by_module")
          .then(res => {
            this.ReportName = res.data;
            this.formSchema.pro_id = res.p_id;
            this.base_path = res.base_path;
          });
      },
    },

    created() {
      let root = this;
      // Asset Location List
      commonService.getAllData("get_menu_info").then(res => {
        root.MainMenus = res.data;
      });
    },
   
    methods: {

      validateBeforeSubmit(e) {
        var formSchema = this.formSchema
        var root = this

        if (this.$refs.form.validate()) {
          if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(this.formSchema, 'report_note').then(res => {
                let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status
              };
              this.close(actionData);
            });
          }
          else
          {            
            commonService.insertFormData(this.formSchema, 'report_note').then(res => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status
              };
              this.close(actionData);
            });
          }
        }  
      },

      close(data){
        if(data.status == 1)
      		{
				 this.$refs.form.reset();
				 }				
				this.$emit('emitCloseModal', data)
      },

      reset() {
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },

    },
}
</script>



// WEBPACK FOOTER //
// src/components/procurement/thresholds/report_note_form.vue